import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../../_helpers/fetch-wrapper";
import { NEWS_GET_LIST } from "../../constants/endpoints";
import { NewsModel } from "../../models/NewsModel";

export const newsGetList = createAsyncThunk(
    'news/list',
    async () => {
        const news: NewsModel[] = await fetchWrapper.get(`${NEWS_GET_LIST}`);
        return news;
    }
);